import Map, { MAPTYPE } from "@/components/map/Map";
import { useCallback } from "react";

interface Props {
    latitude: number;
    longitude: number;
    onChange: (latitude: number, longitude: number) => void;
}

const OrganizationMap = ({ latitude, longitude, onChange }: Props) => {

    const loadMap = useCallback(
        (map: any, maps: any) => {
            const position = {
                lat: latitude,
                lng: longitude,
            };
            const marker = new maps.Marker({
                position,
                map,
                draggable: true,
            });
            marker.addListener("dragend", () => {
                const newLatitude = marker.getPosition().lat();
                const newLongitude = marker.getPosition().lng();
                onChange(newLatitude, newLongitude);
            });
        },
        [latitude, longitude],
    );
    return (
        <>
            <Map height="250px" googleApiLoaded={({ map, maps }) => loadMap(map, maps)} type={MAPTYPE.HYBRID} />
        </>
    );
};

export default OrganizationMap;